import enviro from 'enviro';
import { defaultClientOptions } from '../constants/defaultClientOptions';
export const getDefaultClientOptions = () => {
  const hublet = enviro.getHublet();
  return defaultClientOptions[hublet] || defaultClientOptions['na1'];
};